import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import IndexRepository from '../Repositories/IndexRepository'

class IndexBloc {

    statusChannel = new Subject()
    repository = new IndexRepository()

    constructor() {
        this.statusChannel.next({ status: apiResponse.INITIAL }) 
    }

    fetchStatus = async (query, cancelToken) => {
        this.statusChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchStatus(query, cancelToken).then((result) => {
                this.statusChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.statusChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }



}

export default IndexBloc